import { useEffect, useRef, useState } from 'react'
import {
  SActionBtn,
  SAside,
  SDrawerOrModal,
  SLowcodeList,
  SMessage,
  SSkuCard,
  STableActions,
} from 'shj-components'
import { config, getConfig } from './config'
import styles from '../../index.module.less'
import {
  copyProductInfo,
  getBrandList,
  getProductCategoryTreeList,
  getProductEnums,
  getProductManagementPage,
  productManagementDelete,
  updateProductEnabled,
  importBaseProductInfo,
  salePriceCheck,
  addBudgetArea,
  getBudgetAreaList,
  updateBudgetArea,
  delBudgetArea,
  getSpecialCodesList,
  batchDeleteProduct,
  batchUpdateApplyMaterialSelections,
  productManagementDetail,
  getProdCateTree,
} from '@/services/product'
import { pushGoodsInitInfoByProdId } from '@/services/goods'
import { DownloadOutlined, UploadOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { useNavigate, useLocation } from 'react-router-dom'
import { apiData2Table } from '@/utils/data'
import { fileDownload } from '@/utils/download.ts'
import { getBizOpTypeEnum } from '@/services/customerServices'
import UrlConfig from '@/api/UrlConfigs.ts'
import { useSetState,useUpdateEffect } from 'ahooks'
import { httpOrgList } from '@/services/homeService.ts'
import ProductDetailDrawerSpuSku from '@/components/ProductDetailDrawerSpuSku'
import { Form, message, Switch, Tooltip, Upload, Button, Select, Radio, Input } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import CombinationDetailsModal from "@/pages/productManage/components/CombinationDetailsModal";
import SKUDetailsModal from "@/pages/productManage/components/SKUDetailsModal";
import DefineNameModal from "@/pages/productManage/components/DefineNameModal";

export default function TreeSearchTable(props) {
  const listRef = useRef<any>(null)
  const areaListRef = useRef<any>(null)
  const navigate = useNavigate()
  const location = useLocation()
  const [prodCateIds, setProdCateIds] = useState<any>([])
  const [companyList, setCompanyList] = useState<any>([])
  const [treeData, setTreeData] = useState<any>([])
  const [copyOpen, setCopyOpen] = useState(false)
  const [copyForm] = Form.useForm()
  const [areaForm] = Form.useForm()
  const [applyMaterialForm] = Form.useForm()
  const [record, setRecord] = useState<any>({})
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [importLoading, setImportLoading] = useState(false)
  const [exportLoading, setExportLoading] = useState(false)
  const [applyMaterialLoading, setApplyMaterialLoading] = useState(false)
  const [areaOpen, setAreaOpen] = useState(false)
  const [addAreaOpen, setAddAreaOpen] = useState(false)
  const [applyMaterialOpen, setApplyMaterialOpen] = useState(false)
  const [applyMaterialList, setApplyMaterialList] = useState(false)
  const [selectIdList, setSelectIdList] = useState(false)

  const [chooseProductId, setChooseProductId] = useState('')
  const [chooseAreaId, setChooseAreaId] = useState('')
  const [isEditArea, setIsEditArea] = useState(false)
  const [confirmAreaLoading, setConfirmAreaLoading] = useState(false)
  const [chooseDisabled, setChooseDisabled] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [dataList, setDataList] = useState([])
  const [totalCount, setTotalCount] = useState(0)
  const [combinationModalOpen, setCombinationModalOpen] = useState(false)
  const [skuDetailModalOpen, setSkuDetailModalOpen] = useState(false)
  const [defineNameModalOpen, setDefineNameModalOpen] = useState(false)
  const [minimumArea, setMinimumArea] = useState(null)
  const [maximumArea, setMaximumArea] = useState(null)
  const [previewObj, setPreviewObj] = useSetState<any>({
    open: false,
    loading: false,
    descType: [],
    data: {},
  })
  useEffect(() => {
    getTreeData()
    getCompanyList()
  }, [])

  const getCompanyList = async () => {
    const companyList = await httpOrgList()
    setCompanyList([...companyList])
  }

  const areaConfig = {
    rowSelection: false,
    columns: [
      {
        title: '适用门店',
        dataIndex: 'shopName',
        width: 200,
        name: 'shopName',
        ellipsis: {
          showTitle: false,
        },
      },
      {
        title: '报价面积类型',
        dataIndex: 'areaTypeName',
        width: 120,
        ellipsis: {
          showTitle: false,
        },
      },
      {
        title: '报价面积范围',
        dataIndex: 'areaScale',
        width: 120,
        ellipsis: {
          showTitle: false,
        },
        render: (text, record) => <span>{(!record?.minimumArea || record?.minimumArea === -1) ? '无限' : record?.minimumArea} ~ {(!record?.maximumArea || record?.maximumArea === -1) ? '无限' : record?.maximumArea}</span>
      },
      {
        title: '操作',
        key: 'action',
        width: 120,
        render: 'actionRender',
        fixed: 'right',
      },
    ],
    footer: [
      {
        label: '新增配置',
        //   auth: 'priceButton1',
        type: 'primary',
        events: ['onClick:onAdd'],
      },
    ],
  }

  const getTreeData = () => {
    getProdCateTree({productLibrary: props.type}).then((res: any) => {
      setTreeData([{cateName: '不限', id: '0'}, ...res])
    })
  }
  useUpdateEffect(() => {
    listRef.current?.reload()
  }, [prodCateIds])
  //   左侧树节点事件
  const onChangeType = (node: any, info) => {
    console.log(info)
    setProdCateIds([])
    if (info.selected) {
      setProdCateIds(prevIds => [...prevIds, info.node.id])
      findAllChildsId(info.node)
    }
  }
  const findAllChildsId = (node: any) => {
    if (node.children && node.children.length > 0) {
      node.children.forEach(child => {
        setProdCateIds(prevIds => [...prevIds, child.id])
        findAllChildsId(child)
      })
    }
    // children.forEach((item: any) => {
    //   setProdCateIds([...prodCateIds, item.id])
    //   if (item.children && item.children.length > 0) {
    //     findAllChildsId(item.children)
    //   }
    // })
  }
  //   右侧数据查询
  const fetchList = values => {
    const { current, pageSize, ...rest } = values
    rest.query.modeFlags = [1, 2]
    if (!prodCateIds || prodCateIds[0] == '0') {
      rest.query.prodCateIds = []
    } else {
      rest.query.prodCateIds = prodCateIds
    }
    if (props.type === 'SOLUTION_LIBRARY') {
      rest.query.prodTypes = ['PRODUCT_PACKAGE']
    }
    if (props.type === 'RETAIL_LIBRARY') {
      rest.query.prodTypes = ['PRODUCT_SINGLE', 'PRODUCT_GROUP', 'PRODUCT_BASIC_ITEM']
    }

    return new Promise(async (resolve, reject) => {
      try {
        const data = await getProductManagementPage({
          params: { pageId: current, pageSize },
          data: rest.query,
        })
        resolve(apiData2Table(data))
        setTotalCount(data?.count)
        setDataList(data?.list)
      } catch (err) {
        reject({ success: false })
      }
    })
  }
  //   下拉选项加载
  const getOptions = async () => {
    return new Promise(resolve => {
      Promise.all([
        getProductEnums('com.shj.saas.plus.product.enums.ProductTypeEnum'),
        getBizOpTypeEnum(),
        getBrandList({}),
        getSpecialCodesList({ data: {} }),
        getProductEnums('com.shj.saas.plus.product.enums.ApplyMaterialSelection'),
        getProductEnums('com.shj.saas.plus.product.enums.ProductSourceType'),
      ]).then((res: any) => {
        const obj = {
          productTypeList: res[0].map((item: any) => {
            return { label: item.description, value: item.key }
          }),
          demandList: res[1].map((item: any) => {
            return { label: item.description, value: item.key }
          }),
          brandList: res[2]?.map((item: any) => {
            return { label: item.name, value: item.id }
          }),
          specialCodeList: res[3],
          applyMaterialList: res[4]?.map((item: any) => {
            return { label: item.description, value: item.key }
          }),
          sourceTypeList: res[5]?.map((item: any) => {
            return { label: item.description, value: item.key }
          }),
        }
        setApplyMaterialList(
          res[4]?.map((item: any) => {
            return { label: item.description, value: item.key }
          })
        )
        // setState({ ...state, ...obj })
        resolve({ ...obj })
      })
    })
  }
  // 新增产品
  const onAdd = () => {
    navigate(`/config/productManage/productSteps?activeTabKey=${props.activeTabKey}`)
  }

  // 发布
  const onPublicProduct = async record => {
    try {
      await salePriceCheck(record.id)
    } catch (err) {
      message.info('无销售指导价，不能发布')
      return
    }
    pushGoodsInitInfoByProdId(record.id).then(res => {
      console.log(res)
      if (res && res.id) {
        navigate(`/config/commodityManage/commodityEdit/${res.id}`)
      }
    })
  }
  // 编辑
  const onEdit = record => {
    navigate(`/config/productManage/productSteps/${record.id}?activeTabKey=${props.activeTabKey}`)
  }
  // 打包模板
  const clickToPackageTemplate = record => {
    localStorage.setItem('packHistoryPath', location.pathname)
    navigate(`/config/baseProduct/packageTemplate/addOrEdit/${record.packModelId}`)
  }
  // 复制
  const onCopy = record => {
    setRecord(record)
    setCopyOpen(true)
    copyForm.setFieldsValue({
      prodName: record.prodName,
    })
  }
  const onCopyCommit = () => {
    copyForm.validateFields().then(() => {
      const values = copyForm.getFieldsValue()
      setConfirmLoading(true)
      copyProductInfo({ ...values, prodId: record.id })
        .then((res: any) => {
          setCopyOpen(false)
          setConfirmLoading(false)
          listRef.current?.reload()
        })
        .finally(() => {
          setConfirmLoading(false)
        })
    })
  }
  // 删除
  const onDel = id => {
    SMessage.confirm({
      onOk: () => {
        return productManagementDelete(id).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  const onSelect = () => {
    navigate('/config/chooseCategory')
  }

  const onImport = async (upload: any) => {
    setImportLoading(true)
    const { file, onSuccess, onError } = upload
    const data = new FormData()
    data.append('file', file)
    try {
      const res: any = await importBaseProductInfo(data)
      listRef.current && listRef.current.reload()
      onSuccess && onSuccess()
      if (res?.length) {
        let str = ''
        res.forEach((item, index) => {
          if (item?.errorMessages?.length) {
            str =
              str +
              ' ' +
              `第${item.lineNumber}行` +
              '、' +
              item?.errorMessages.join('、')?.slice(0, 100)
          }
        })
        str = str?.slice(0, 300)
        if (str !== '') {
          message.error(str)
        } else {
          message.success(res.message || '导入成功')
        }
      } else {
        message.success(res.message || '导入成功')
      }
      setImportLoading(false)
    } catch (err) {
      setImportLoading(false)
      console.log(err)
    }
  }

  const onExport = async () => {
    try {
      setExportLoading(true)
      await fileDownload(UrlConfig.PlusProductWeb.DownloadBaseProductInfo)
      setExportLoading(false)
    } catch (err) {
      setExportLoading(false)
      console.log(err)
    }
  }

  const openAreaModal = record => {
    setChooseProductId(record.id)
    setAreaOpen(true)
  }

  const onAddArea = () => {
    areaForm.resetFields()
    areaForm.setFieldValue('areaType', 'INNER_AREA')
    setMinimumArea('')
    setMaximumArea('')
    setIsEditArea(false)
    setAddAreaOpen(true)
  }

  const onAreaEdit = (record: any) => {
    areaForm.resetFields()
    setChooseAreaId(record?.id)
    areaForm.setFieldValue('areaType', record?.areaType)
    setMinimumArea((!record?.minimumArea || record?.minimumArea === -1) ? '' :  record?.minimumArea)
    setMaximumArea((!record?.maximumArea || record?.maximumArea === -1) ? '' :  record?.maximumArea)
    setIsEditArea(true)
    setAddAreaOpen(true)
  }

  const onAreaDel = async id => {
    SMessage.confirm({
      onOk: () => {
        return delBudgetArea(id).then((res: any) => {
          if (res?.message === '操作成功') {
            message.success('删除成功')
            areaListRef?.current?.reload()
          }
        })
      },
    })
  }

  const onAreaTypeConfirm = () => {
    areaForm.validateFields().then(async value => {
      if (maximumArea && minimumArea && (maximumArea <= minimumArea)) {
        message.error('最大面积必须大于最小面积')
        return;
      }
      if (maximumArea && maximumArea < 0) {
        message.error('最大面积必须大于0')
        return;
      }
      if (minimumArea && minimumArea < 0) {
        message.error('最小面积必须大于0')
        return;
      }
      try {
        setConfirmAreaLoading(true)
        let res: any = {}
        if (!isEditArea) {
          res = await addBudgetArea({ productId: chooseProductId, ...value, areaScale: '', maximumArea: maximumArea || -1, minimumArea: minimumArea || -1 })
        } else {
          res = await updateBudgetArea({ id: chooseAreaId, areaType: value.areaType, maximumArea: maximumArea || -1, minimumArea: minimumArea || -1 })
        }
        setConfirmAreaLoading(false)
        if (res.length || res.id) {
          message.success(isEditArea ? '编辑成功' : '添加成功')
          areaListRef?.current?.reload()
          setAddAreaOpen(false)
        }
      } catch (err) {
        setConfirmAreaLoading(false)
      }
    })
  }

  //   右侧数据查询
  const fetchAreaList = async () => {
    const res: any = await getBudgetAreaList({
      productId: chooseProductId,
    })
    return {
      records: res,
      total: res?.length,
    }
  }
  const onApplyMaterialSelect = ({ selectedRowKeys }) => {
    setApplyMaterialOpen(true)
    setSelectIdList(selectedRowKeys)
  }
  const onApplyMaterial = () => {
    const searchValues = listRef.current?.getSearch()?.getFieldsValue()
    if (!(!prodCateIds || prodCateIds[0] == '0')) {
      searchValues.prodCateIds = prodCateIds
    }
    applyMaterialForm.validateFields().then(async value => {
      try {
        setApplyMaterialLoading(true)
        batchUpdateApplyMaterialSelections({
          data: {
            productIds: chooseDisabled ? undefined : selectIdList,
            query: chooseDisabled ? { prodTypes : ['PRODUCT_SINGLE', 'PRODUCT_GROUP', 'PRODUCT_BASIC_ITEM'], ...searchValues } : undefined,
            ...value },
        })
          .then((res: any) => {
            setApplyMaterialLoading(false)
            message.success('操作成功')
            setChooseDisabled(false)
            setSelectedRowKeys([])
            listRef.current?.clearSelectedRowKeys()
            listRef.current?.reload()
            setApplyMaterialOpen(false)
            applyMaterialForm.resetFields()
          })
          .finally(() => {
            setApplyMaterialLoading(false)
          })
      } catch (err) {
        setApplyMaterialLoading(false)
      }
    })
  }
   const batchDelete = ({ selectedRowKeys, selectedRows }:any) => {
    SMessage.confirm({
      onOk: () => {
        return batchDeleteProduct({
          ids: selectedRowKeys,
        }).then(() => {
          listRef.current?.reload()
        })
      },
      title: `确定删除这些产品吗？`,
      content: null,
    })
  }
  const batchEnable = ({ selectedRowKeys, selectedRows }:any) => {
    const searchValues = listRef.current?.getSearch()?.getFieldsValue()
    if (!(!prodCateIds || prodCateIds[0] == '0')) {
      searchValues.prodCateIds = prodCateIds
    }
    SMessage.confirm({
      onOk: () => {
        return updateProductEnabled({
          ids: chooseDisabled ? undefined : selectedRowKeys,
          query: chooseDisabled ? { prodTypes : ['PRODUCT_SINGLE', 'PRODUCT_GROUP', 'PRODUCT_BASIC_ITEM'], ...searchValues } : undefined,
          enabled: true,
        }).then(() => {
          listRef.current?.reload()
          setSelectedRowKeys([])
          listRef.current?.clearSelectedRowKeys()
          setChooseDisabled(false)
        })
      },
      title: `确定启用这些产品吗？`,
      content: null,
    })
  }
  const batchDisable = ({ selectedRowKeys, selectedRows }:any) => {
    const searchValues = listRef.current?.getSearch()?.getFieldsValue()
    if (!(!prodCateIds || prodCateIds[0] == '0')) {
      searchValues.prodCateIds = prodCateIds
    }
    SMessage.confirm({
      onOk: () => {
        return updateProductEnabled({
          ids: chooseDisabled ? undefined : selectedRowKeys,
          query: chooseDisabled ? { prodTypes : ['PRODUCT_SINGLE', 'PRODUCT_GROUP', 'PRODUCT_BASIC_ITEM'], ...searchValues } : undefined,
          enabled: false,
        }).then(() => {
          listRef.current?.reload()
          setSelectedRowKeys([])
          listRef.current?.clearSelectedRowKeys()
          setChooseDisabled(false)
        })
      },
      title: `确定禁用这些产品吗？`,
      content: null,
    })
  }
  const onOpenProductDetail = (record:any)=>{
    console.log(record)
    setPreviewObj({ open: true, loading: true })
    productManagementDetail(record?.id).then((res:any)=>{
      console.log(res)
      res.name = 'SPU名称'
      setPreviewObj({
          data: res,
      })
    }).finally(() => setPreviewObj({ loading: false }))
  }

  // 右侧表格事件：
  const allSelect = () => {
    console.log(dataList, 'changeSize')
    if (chooseDisabled) {
      setChooseDisabled(false)
      listRef?.current?.clearSelectedRowKeys()
    } else {
      setChooseDisabled(true)
      const ids: any = dataList?.map((item: any) => item.id)
      setSelectedRowKeys(ids)
    }
  }

  const onDefineName = () => {
    setDefineNameModalOpen(true)
  }

  const extensions = {
    request: { fetchList, getOptions },
    events: {
      onAdd,
      onSelect,
      batchDisable,
      batchEnable,
      batchDelete,
      onApplyMaterialSelect,
      allSelect,
      onDefineName,
    },
    scroll: {y: `calc(100vh - 390px)`},
    getCheckboxProps: () => ({
      disabled: chooseDisabled,
    }),
    selectedRowKeys: selectedRowKeys,
    onSelectedRowChange: (keys) => {
      setSelectedRowKeys(keys)
    },
    status: {
      deleteDisabled: ({selectedRowKeys, selectedRows}: any) => {
        return selectedRows?.some((item: any) => item.enabled) || chooseDisabled
      },
      // exportLoading: state.exportLoading,
    },
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            {record.enabled ? (
              <SActionBtn onClick={() => onPublicProduct(record)}>发布</SActionBtn>
            ) : null}
            <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
            {props.type === 'RETAIL_LIBRARY' && record.prodType === 'PRODUCT_GROUP' && <SActionBtn onClick={() => {
              setCombinationModalOpen(true);
              setRecord(record);
            }}>组合明细</SActionBtn>}
            {props.type === 'RETAIL_LIBRARY' && <SActionBtn onClick={() => {
              setSkuDetailModalOpen(true)
              setRecord(record);
            }}>SKU明细</SActionBtn>}
            {record.packModelId ? (
              <SActionBtn onClick={() => clickToPackageTemplate(record)}>打包模板</SActionBtn>
            ) : null}
            {record?.hasBudgetAreaConfig ? (
              <SActionBtn onClick={() => openAreaModal(record)}>报价面积</SActionBtn>
            ) : null}
            <SActionBtn onClick={() => onCopy(record)}>复制</SActionBtn>
            {!record.enabled ? (
              <SActionBtn danger onClick={() => onDel(record.id)}>
                删除
              </SActionBtn>
            ) : null}
          </STableActions>
        )
      },
      renderProduct(_, record: Record<string, any>) {
        return (
          <SSkuCard
            width={'100%'}
            url={record.mainPicUrl || ''}
            desc={record.id}
            operation={() => {
              return <div></div>
            }}
            title={
              <Tooltip title={record.prodName}>
                <a className={styles.showTwoLinehidden}  onClick={() => onOpenProductDetail(record)}>{record.prodName}</a>
              </Tooltip>
            }
          ></SSkuCard>
        )
      },
      enableRender(_, record: Record<string, any>) {
        return (
          <Switch
            checkedChildren="启用"
            unCheckedChildren="停用"
            checked={record.enabled ? true : false}
            onChange={e => {
              SMessage.confirm({
                onOk: () => {
                  return updateProductEnabled({
                    ids: [record.id],
                    enabled: e,
                  }).then(() => {
                    listRef.current?.reload()
                  })
                },
                title: `确定${e ? '启用' : '停用'}该产品吗？`,
                content: null,
              })
            }}
          />
        )
      },
      importRender: () => {
        return (
          <Upload listType="text" customRequest={onImport} itemRender={() => null}>
            <Button
              type={'primary'}
              loading={importLoading}
              disabled={importLoading}
              icon={<UploadOutlined />}
            >
              批量导入
            </Button>
          </Upload>
        )
      },
      exportRender: () => {
        return (
          <Button
            icon={<DownloadOutlined />}
            onClick={onExport}
            disabled={exportLoading}
            loading={exportLoading}
            type="dashed"
          >
            下载导入模板
          </Button>
        )
      },
    },
    // scroll: { x: 'max-content', y: '580px' },

  }

  const areaExtensions = {
    request: { fetchList: fetchAreaList },
    events: {
      onAdd: onAddArea,
    },
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onAreaEdit(record)}>编辑</SActionBtn>
            {record.shopId !== '0' ? (
              <SActionBtn danger onClick={() => onAreaDel(record.id)}>
                删除
              </SActionBtn>
            ) : null}
          </STableActions>
        )
      },
    },
  }

  return (
    <div className={styles.treeTable}>
      <div className={styles.leftMenu}>
        {/* 左侧树形选择 */}
        <SAside
          treeData={treeData}
          onSelect={onChangeType}
          title={''}
          treeType="tree"
          defaultSelectedKeys={['0']}
          // active={state.categoryCode}
          fieldNames={{ title: 'cateName', key: 'id' }}
          header={false}
          dropItems={false}
        />
      </div>
      {/* 右侧表格数据 */}
      <div className={styles.rightTable}>
        <SLowcodeList ref={listRef} searchMode="group" config={getConfig(props.type)} {...extensions}
                      rowSelectedTotal={chooseDisabled ? totalCount : ''}/>
      </div>

      <SDrawerOrModal
        mode="modal"
        open={copyOpen}
        onCancel={() => setCopyOpen(false)}
        onOk={onCopyCommit}
        title="复制产品"
        loading={confirmLoading}
        width={600}
      >
        {record && (
          <Form
            initialValues={{ prodName: '' }}
            autoComplete="off"
            form={copyForm}
            layout="vertical"
          >
            <Form.Item
              label="新对象名称"
              name="prodName"
              rules={[{ required: true, message: '请输入新对象名称' }]}
            >
              <TextArea maxLength={100} style={{ width: '100%' }} showCount />
            </Form.Item>
          </Form>
        )}
      </SDrawerOrModal>

      {areaOpen ? (
        <SDrawerOrModal
          mode="drawer"
          open={areaOpen}
          antdProps={{ footer: null }}
          onCancel={() => setAreaOpen(false)}
          title="报价面积"
        >
          <SLowcodeList
            ref={areaListRef}
            searchMode="group"
            config={areaConfig}
            {...areaExtensions}
          />
        </SDrawerOrModal>
      ) : null}

      {addAreaOpen ? (
        <SDrawerOrModal
          mode="modal"
          width={500}
          open={addAreaOpen}
          onCancel={() => setAddAreaOpen(false)}
          onOk={onAreaTypeConfirm}
          title="新增配置"
          loading={confirmAreaLoading}
        >
          <Form labelCol={{ span: 6 }} autoComplete="off" form={areaForm}>
            {!isEditArea ? (
              <Form.Item
                label="适用门店"
                name="shopIds"
                rules={[{ required: true, message: '请选择适用门店' }]}
              >
                <Select
                  mode={'multiple'}
                  optionFilterProp={'name'}
                  placeholder={'请选择适用门店'}
                  fieldNames={{ label: 'name', value: 'id' }}
                  options={[...companyList]}
                />
              </Form.Item>
            ) : null}
            <Form.Item
              label="报价面积类型"
              name="areaType"
              rules={[{ required: true, message: '请选择报价面积类型' }]}
            >
              <Radio.Group>
                <Radio value="INNER_AREA">套内面积</Radio>
                <Radio value="CONSTRUCT_AREA">建筑面积</Radio>
                <Radio value="OUTER_FRAME_AREA">外框面积</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              label={(<div>
                <Tooltip title="不填默认为不限制">
                  <span>
                    <QuestionCircleOutlined /> 报价面积范围
                  </span>
                </Tooltip>
              </div>)}
              name="areaScale"
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Input
                  value={minimumArea || ''}
                  onChange={(e) => setMinimumArea(Math.floor(Number(e?.target?.value)) || '')}
                  style={{ width: '120px' }}
                  placeholder='最小面积'
                  type='number'
                  min={0}
                  precision={0}
                ></Input>
                <div>&nbsp; ~ &nbsp;</div>
                <Input
                  value={maximumArea || ''}
                  onChange={(e) => setMaximumArea(Math.floor(Number(e?.target?.value)) || '')}
                  style={{ width: '120px' }}
                  placeholder='最大面积'
                  type='number'
                  min={0}
                  precision={0}
                ></Input>
              </div>
            </Form.Item>
          </Form>
        </SDrawerOrModal>
      ) : null}

      <SDrawerOrModal
        mode="modal"
        open={applyMaterialOpen}
        onCancel={() => {
          setApplyMaterialOpen(false)
          applyMaterialForm.resetFields()
        }}
        onOk={onApplyMaterial}
        title="适用选材"
        loading={applyMaterialLoading}
        width={600}
      >
        {applyMaterialOpen && (
          <Form
            initialValues={{ prodName: '' }}
            autoComplete="off"
            form={applyMaterialForm}
            layout="vertical"
          >
            <Form.Item
              label="适用选材"
              name="applyMaterialSelections"
              // rules={[{ required: true, message: '请选择适用选材' }]}
            >
              <Select
                showArrow
                showSearch
                placeholder="请选择适用选材"
                options={applyMaterialList}
                optionFilterProp="label"
                mode="multiple"
              />
            </Form.Item>
          </Form>
        )}
      </SDrawerOrModal>
      {previewObj.open && (
        <ProductDetailDrawerSpuSku
          previewObj={previewObj}
          setPreviewObj={setPreviewObj}
        />
      )}
      {combinationModalOpen && <CombinationDetailsModal
        open={combinationModalOpen}
        record={record}
        onClose={() => setCombinationModalOpen(false)}
        onReload={listRef.current?.reload}
      />}
      {skuDetailModalOpen && <SKUDetailsModal
        open={skuDetailModalOpen}
        isEdit={true}
        spuData={record}
        onClose={() => setSkuDetailModalOpen(false)}
        onReload={listRef.current?.reload}
      />}
      {defineNameModalOpen && <DefineNameModal
        open={defineNameModalOpen}
        onClose={() => setDefineNameModalOpen(false)}
        onReload={listRef.current?.reload}
      />}
    </div>
  )
}
